<script setup lang="ts">

import {ProjectType, ProjectTypeSummary} from "../models/project";
import ProjectTypeSelect from "./ProjectTypeSelect.vue";
import {useProjectTypesList} from "../composables/project";
import {ref, watch} from "vue";

const {data: projectTypes, isFetching} = useProjectTypesList()
const model = defineModel<number | null>()
const props = defineProps<{
  initialValue?: ProjectType
}>()

const projectType = ref<ProjectType | ProjectTypeSummary | null>(props.initialValue ?? null)

watch(projectType, (newValue) => {
  if (newValue) {
    model.value = newValue.id
  } else {
    model.value = null
  }
})
</script>

<template>
  <q-select dense v-model="projectType" clearable :loading="isFetching" :options="projectTypes"
            option-label="name" option-value="id" label="Категория" emit-value behavior="menu" map-options>
    <template v-slot:option="scope">
      <ProjectTypeSelect :item="scope.opt" :level="0" :selected-id="projectType?.id"
                         @select="(item: ProjectTypeSummary) => projectType = item"/>
    </template>
  </q-select>
</template>

<style scoped>

</style>